import { render, staticRenderFns } from "./OnboardingDateOfBirth.vue?vue&type=template&id=4eb70d79&scoped=true&"
import script from "./OnboardingDateOfBirth.vue?vue&type=script&lang=js&"
export * from "./OnboardingDateOfBirth.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDateOfBirth.vue?vue&type=style&index=0&id=4eb70d79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb70d79",
  null
  
)

export default component.exports